module.exports = "../static/media/icon_twitter.504a4483.png";